import { getMatchingSubstring } from './getMatchingSubstring';

export function filterSearchResults(entries, term, type, filterOn, saveMatchingToken = false) {
	let terms = null;
	if (term != null && term.length > 0) {
		terms = term.toLowerCase().trim().split(' ');
	} else {
        return entries;
    }
    
    const isNumber = !isNaN(Number(term));
    if (isNumber && type === 'MATCH') {
        return entries.filter(entry => {
            return entry.alias != null ? entry.alias.startsWith(term): false;
        });
    } else {
        return entries.filter(entry => {
            const entryString = filterOn(entry)?.toLowerCase() ?? null;
			if (entryString == null) {
				return false;
			}
            if (terms.length > 1) {
                let isMatch = false;
                for (let i = 0; i < terms.length; i++) {
                    const term = terms[i];
                    const index = entryString.indexOf(term);
                    if (index === -1) {
                        isMatch = false;
                        break;
                    } else {
                        isMatch = true;
                        if (saveMatchingToken) {
                            entry.matchingToken = getMatchingSubstring(entryString, index);
                        }
                    }
                }
    
                if (isMatch) {
                    return entry;
                }
            } else {
                const index = entryString.indexOf(terms[0]);
                if (index !== -1) {
                    if (saveMatchingToken) {
                        entry.matchingToken = getMatchingSubstring(entryString, index);
                    }
                    return entry;
                }
            }
            
            return false;
        });
    }
}
